export interface ISerializedWizardFocus {
    nodeStateName: string;
    nodeSubjectIndex: number;
}

// note to future self:  When asked the question:  why not use the serialized version of WizardFocus everywhere, instead of converting only on save,
// the answer is:  because the save memorizes the indexes of sub-items like location, but at runtime, the index can change (from deletions/additions)
// so, the "live" wizard focus uses the actual data element, and is not dependent upon the index, which is untrustworthy if the user changes data
export class SerializedWizardFocus implements ISerializedWizardFocus {
    public nodeStateName: string;
    public nodeSubjectIndex: number;
}